import { VbzButton } from "@smiles/voebiz-ui-kit";
import React, { FC } from "react";
import { ModalBody } from "reactstrap";

interface ErrorProps {
  onClick: any;
}

const ModalErrorBody: FC<ErrorProps> = ({ onClick }) => (
  <ModalBody>
    <div className="vbz-modal-header">
      <h4 className="modal-title-wrapper">Não foi possível atualizar seus dados</h4>
    </div>
    <div >
      <p className="modal-text-wrapper">
        Houve uma falha durante a atualização dos seus dados. Por favor, tente de novo em instantes.
      </p>

      <VbzButton
        id="submit"
        className="mt-5 smls-register-cpf"
        color="primary"
        text="Tentar de novo"
        onClick={onClick}
      />
    </div>
  </ModalBody>
);

export default ModalErrorBody;
